<template>
  <div class="main-news-page-wrapper">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <main class="news-wrapper">
      <template v-if="!loading && total_count > 0">
        <div class="news-posts">
          <a class="news-post-wrapper" v-for="news_post in news_posts" :href="`/news/${news_post.id}`">
            <div class="news-post">
              <div class="news-post-image">
                <img :src="`${$aws_bucket_url}${news_post.main_image_url}`">
              </div>
              <div class="news-post-content">
                <div class="title">
                  <h1>{{ news_post.title }}</h1>
                </div>
                <div class="date">
                  {{ news_post.formatted_publish_at }}
                </div>
                <div class="summary">
                  {{ news_post.summary }}
                </div>
                <div class="footer">
                  <a class="btn-primary _sm">Read More</a>
                </div>
              </div>
            </div>
          </a>
        </div>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3 pl-3 pr-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong>
          No Results Found
        </strong>
      </template>
    </main>
    <aside class="news-sidebar-wrapper">
      <div class="news-sidebar">
        <div class="category-list">
          <div class="title">
            Categories
          </div>
          <div class="category"
               @click="selected_category_id = null"
               :class="{ '_active' :  selected_category_id === null}">
            All
          </div>
          <div class="category"
               v-for="category in categories"
               @click="selected_category_id = category.id"
               :class="{ '_active' :  selected_category_id === category.id}">
            {{ category.label }}
          </div>
        </div>
        <div class="news-search">
          <div class="form-group">
            <input type="text" placeholder="Search" class="form-control _slim" v-model="search_query">
          </div>
          <div class="form-group">
            <div class="multi-select-input">
              <div class="multi-select-input-placeholder" @click="system_dropdown_open = !system_dropdown_open">
                <template v-if="selected_system_types.length > 0">
                  <span v-for="type in selected_system_types">{{ type.label }}, </span>
                </template>
                <template v-else>
                  Select Systems ...
                </template>
                <div class="dropdown-icon">
                  <i class="fal fa-chevron-down"></i>
                </div>
              </div>
              <div class="multi-select-input-inner" v-show="system_dropdown_open">
                <div class="multi-select-input-group">
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="system_type in system_types">
                      <label>
                        <input type="checkbox" name="epwin_system_types" :value="system_type.id" v-model="selected_system_type_ids">
                        <span class="checkbox-label">{{ system_type.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>

export default {
  props: [
    'categories',
    'system_types',
  ],
  data() {
    return {
      news_posts: [],
      search_query: '',
      current_page: 1,
      total_count: 0,
      total_pages: 0,
      selected_category_id: null,
      selected_system_type_ids: [],
      limit: 20,
      loading: true,
      system_dropdown_open: false,
    };
  },
  computed: {
    selected_system_types() {
      return this.system_types.filter((type) => this.selected_system_type_ids.includes(type.id));
    },
  },
  mounted() {
    this.loadNewsPosts();
  },
  methods: {
    loadNewsPosts: _.debounce(function () {
      axios.post('/news/loadPosts', {
        news_post_category_id: this.selected_category_id,
        epwin_system_type_ids: this.selected_system_type_ids,
        page_number: this.current_page,
        search_query: this.search_query,
        limit: this.limit,
      }).then((response) => {
        this.news_posts = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.loadNewsPosts();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.loadNewsPosts();
    }
  },
  watch: {
    search_query() {
      this.current_page = 1;
      this.loadNewsPosts();
    },
    selected_category_id() {
      this.current_page = 1;
      this.loadNewsPosts();
    },
    selected_system_type_ids() {
      this.current_page = 1;
      this.loadNewsPosts();
    },
  },
};
</script>
